import { useEffect, useState } from 'react';
import { LoanApi } from '@apply/api';
import { IBridgeLoanGridRecord } from '@apply/api/src/api/loanApi';
import { ScopedWaitOverlay } from '@apply/components';
import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';
import { applicationInsights } from '../../ApplicationInsights';
import { OutstandingLoansGrid } from './components/OutstandingLoansGrid/OutstandingLoansGrid';

export const BridgeOutstanding = () => {
    const [isLoading, set_isLoading] = useState(true);
    const [loans, set_loans] = useState<IBridgeLoanGridRecord[]>();

    useEffect(() => {
        const loadData = async () => {
            try {
                const response = await new LoanApi.LoanApi(applicationInsights).getBridgeOutstandingLoans();
                set_loans(response.result);
            } finally {
                set_isLoading(false);
            }
        };

        loadData();
    }, []);

    return (
        <>
            <SectionHeaderBar title={'Outstanding'}></SectionHeaderBar>
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <div className='scrollable-content no-search'>
                    <OutstandingLoansGrid data={loans} />
                </div>
                <ScopedWaitOverlay
                    visible={isLoading}
                    label='Retrieving Outstanding Loans...'
                    mode='Admin'
                />
            </div>
        </>
    );
};
